import React from 'react';
import PropTypes from 'prop-types';

import ContactPcsIcon from 'dibs-vg/dist/react/circle-contact-info';
import { FormattedMessage } from 'react-intl';

import styles from './ContactPcs_styles.scss';

const ContactPcs = ({ email, name, phoneNumber }) => {
    const messagePcs = (
        <span className={styles.label}>
            <FormattedMessage id="pdp.ContactPcs.pcs" defaultMessage="Private Client Service:" />
        </span>
    );

    const messageTitle = (
        <FormattedMessage
            id="pdp.ContactPcs.title"
            defaultMessage="{pcs} Contact your specialist, {name}, for dedicated assistance"
            values={{ pcs: messagePcs, name }}
        />
    );

    const messageEmail = (
        <a href={`mailto:${email}`}>
            <FormattedMessage id="pdp.ContactPcs.email" defaultMessage="Email" />
        </a>
    );

    return (
        <div className="pdp-sidebar-icon contact-pcs-container" data-tn="contact-pcs">
            <div className={`${styles.icon} contact-pcs-icon`}>
                <ContactPcsIcon />
            </div>
            <div className={styles.text}>
                <div className={styles.info}>{messageTitle}</div>
                <div className={styles.contact}>
                    <div className={styles.phoneNumber}>{phoneNumber}</div>
                    <div className={styles.email}>{messageEmail}</div>
                </div>
            </div>
        </div>
    );
};

ContactPcs.propTypes = {
    email: PropTypes.string,
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
};

export default ContactPcs;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Pcs/ContactPcs.jsx